<template>
  <div class="product_button_wrap" v-if="$store.state.myRender.common.displayContactRadio === 'block'">
    
    <template v-if="$store.state.app.view_pattern === 'pc'">
    <template v-if="has_cart"> 
    <div class="product_advisory_email ">Add to Cart</div>
    <div class="product_advisory_email">Buy Now</div>
    </template>
    <a v-if="listArr.contactRadio.includes('email')" :href="`mailto:${listArr.email}`" class="product_advisory_email">
    <i class="iconfont icon-youjian"></i>
    <span>{{ listArr.email }}</span>
    </a>
    <div class="product_advisory_btn" style="cursor: default" v-if="listArr.contactRadio.includes('phone')">
        <i class="iconfont icon-phonenew"></i>
        <span>{{ listArr.phone }}</span>
    </div>
    
    <div v-if="listArr.contactRadio.includes('wechat')" class="product_advisory_btn" @click="showVisiable = true">
        <i class="iconfont icon-weixin"></i>
        <span>{{ getLang($t('widgets_basic_product_detail_components_product_button_wrap_2748')) }}</span>
    </div>

    <div v-if="listArr.contactRadio.includes('message')" class="product_advisory_btn" @click="openEditForm">
        <i class="iconfont iconlianxiwomen2"></i>
        <span>{{ getLang('Message') }}</span>
    </div>

    <!-- <a @click.stop="openEditForm" v-if="listArr.contactRadio.includes('message')" class="cover_anchor product_advisory_message">
        <i class="iconfont iconlianxiwomen2"></i>
      </a> -->

    </template>  

    
    <template v-if="$store.state.app.view_pattern === 'mb'">
      <div class="mb-cart" v-if="has_cart">
        <div class="cart_btn">Add to Cart</div>
        <div class="cart_btn">Buy Now</div>
      </div>
      <template v-else>
      <div class="product_advisory_btn btn-product-contact" v-if="listArr.contactRadio.includes('phone')">
        <i class="iconfont icon-phonenew"></i>
        <span>{{ listArr.phone }}</span>
      </div>
      <a :href="`mailto:${listArr.email}`" class="product_advisory_email btn-product-contact"
      :class="listArr.contactRadio.length == 1 ? 'product_advisory_email_new' : ''"
          v-if="listArr.contactRadio.includes('email')">
        <i class="iconfont icon-youjian"></i>
        <span v-if="listArr.contactRadio.length == 1">{{ listArr.email }}</span>
      </a>    
      <div v-if="listArr.contactRadio.includes('wechat')" class="product_advisory_btn btn-product-contact"
            @click="show_contact_box">
        <i class="iconfont icon-weixin"></i>
        <span>{{ getLang($t('widgets_basic_product_detail_components_product_button_wrap_2748')) }}</span>
      </div>
    </template>
    </template>  

  </div>


  
</template>

<script>
import i18n from '../../../language/index'

export default {
  name: 'product_button_wrap',
  data() {
    return {}
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    productInfo: {
      type: Object,
      default: null
    },
  },
  computed: {
    has_cart(){
      return this.$store.state.app.road_type&& this.productInfo.p_5 != 0
    },
    theme_color() {
      return this.$store.state.myRender.common.theme_color
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor
    },
    listArr() {
      return this.module.data.listArr
    }
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    openEditForm() {
      let that = this
      if(that.templet.amp_no_make()){
        return
      }
      that.templet.clickTime(() => {
          const form = that.getForm(
            that.listArr.formID,
            that.$store.state.app.formList
          );
          if(JSON.stringify(form) == "{}"){
            alert(i18n.t('widgets_basic_product_detail_components_product_button_wrap_2749'))
            return false
          }
          console.log('form', typeof form);
          that.$store.commit("app/set_submit_form_isShow", true);
          that.$store.commit("app/set_form", form);
      });
    },
    show_contact_box() {
      if (this.listArr.contactRadio === 'phone') {
        this.$message.error(i18n.t('components_set_link_components_phone_consultation_2462'))
      } else {
        this.showVisiable = true
      }
    },
    getForm(id, data) {
      let obj = {};
      if (id !== "") {
        for (let i = 0; i < data.length; i++) {
          if (data[i].value === id) {
            obj = data[i];
            break;
          }
        }
      }
      return obj;
    },
  }
}
</script>

<style lang="scss" scoped>
  .product_advisory_message {
    display: inline-block;
    margin-bottom: 10px;
    vertical-align: top;    
  }

  .product_advisory_message i{
    width: auto;
    max-width: 100%;
    padding: 0 15px;
    height: 40px;
    color: #fff;
    font-size: 42px;
    line-height: 41px;
    text-align: center;    
    color: var(--theme_color);
    transition: background-color .3s;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .product_advisory_btn {
    width: auto;
    min-width: 150px;
    height: 42px;
    color: #fff;
    font-size: 15px;
    line-height: 42px;
    text-align: center;
    border-radius: 21px;
    background-color: var(--theme_color);
    transition: background-color .3s;
    text-align: left;
    padding-left: 18px;
    padding-right: 18px;
    cursor: pointer;
    .icon-phonenew {
      font-size: 16px;
    }
  }
  .mb-cart{
    display: block;
    width:100%;
    display: flex;
    height:42px;
    
    .cart_btn{
      flex:1;
      text-align: center;
      color:#fff;
      font-size: 15px;
      line-height: 42px;
      background-color: var(--theme_color);
      &:first-child{
        // opacity: 0.8;
        // border-right: 1px solid #fff;
      }
    }
  } 
</style>



// WEBPACK FOOTER //
// src/widgets/basic_product_detail/components/product_button_wrap.vue